import { Badge } from '@/components/shadcn/badge';
import { Card } from '@/components/shadcn/card';

interface PadelMatchNamesBarProps {
  sideA: string;
  sideB: string;
  center: string;
}

export default function PadelMatchNamesBar({ sideA, sideB, center }: PadelMatchNamesBarProps) {
  return (
    <Card className="flex flex-row items-center justify-between rounded-2xl border-0 bg-white px-4 py-3 shadow-[inset_0_0_0_1px_#E0E6ED]">
      <p className="min-w-0 flex-1 text-center text-sm font-extrabold leading-tight text-[#0E1726]">
        {sideA}
      </p>
      <Badge className="mx-2 shrink-0 border-0 bg-[#FFF1EC] px-2 py-1 text-xs font-bold text-[#FC480D] hover:bg-[#FFF1EC]">
        {center}
      </Badge>
      <p className="min-w-0 flex-1 text-center text-sm font-extrabold leading-tight text-[#0E1726]">
        {sideB}
      </p>
    </Card>
  );
}
